import logo from "../../../assets/GenXAI logo.png";

export default function LoginHeader() {
  return (
    <div className="text-left mb-6">
      <img
        src={logo}
        alt="GenXAI Logo"
        className="w-32 h-auto max-w-full mb-4 object-contain"
      />
      <h2 className="text-[2rem] font-bold text-slate-900 dark:text-white mb-1.5 leading-tight">
        Welcome back
      </h2>
      <p className="text-slate-500 dark:text-slate-400 text-[1.05rem]">
        Please enter your details to sign in to your workspace.
      </p>
    </div>
  );
}
